import React from 'react';
import './style.css';

const SuggestionTrigger = ({ onClick }) => {
  return (
    <button className="suggestion-trigger" onClick={onClick} aria-label="Get relationship suggestions">
      💡
    </button>
  );
};

export default SuggestionTrigger;
